module.exports = __webpack_public_path__ + "img/inactive-16.61c0a905.svg";